module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/shield-df36c9ad17f6a0319ab7d7ac825278e7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/shield.svg
// module id = 4HJD
// module chunks = 24